export default __webpack_public_path__ + "static/media/Billing-Adress.d91d07e0.jpg";